import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

export const appConfigStateSelector = createSelector(rootSelector, r => r.appConfig);
